import React from 'react';
import {
  LuChevronRight,
  LuClipboardList,
} from 'react-icons/lu';

export default function HostAgendaCard({
  onClick,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={S.card}
      aria-label="View host agenda"
    >
      <div style={S.iconWrap}>
        <LuClipboardList
          size={18}
          strokeWidth={2.2}
        />
      </div>

      <div style={S.titleWrap}>
        <div style={S.title}>
          Host agenda
        </div>

        <div style={S.sub}>
          View the event plan and host notes
        </div>
      </div>

      <div style={S.chevronWrap}>
        <LuChevronRight
          size={18}
          strokeWidth={2.2}
        />
      </div>
    </button>
  );
}

const S = {
 card: {
    width: "calc(100% - 8px)",
    margin: "12px 4px 12px",
    padding: "11px 12px",
    borderRadius: 12,
    border: "1px solid #EEF0F2",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    gap: 10,
    textAlign: "left",
    cursor: "pointer",
    WebkitTapHighlightColor: "transparent",
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },

  iconWrap: {
    width: 32,
    height: 32,
    borderRadius: 999,
    flexShrink: 0,
    display: 'grid',
    placeItems: 'center',
    background: '#FFFFFF',
    border: '1px solid #EEF0F2',
  },

  titleWrap: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
  },

  title: {
    fontSize: 14,
    fontWeight: 800,
    lineHeight: 1.25,
    color: '#0B0B0B',
  },

  sub: {
    marginTop: 1,
    fontSize: 11,
    lineHeight: 1.3,
    color: '#0B0B0B',
    opacity: 0.9,
  },

  chevron: {
    color: "#111",
    flexShrink: 0,
  },
};